// Avaliações em vídeo.
// Os vídeos ficam guardados em <template> e só entram no DOM quando alguém
// clica: a página carrega apenas as capas, por mais depoimentos que existam.

{
  class MaVideos extends HTMLElement {
    connectedCallback() {
      this.trilho = this.querySelector('[data-trilho]');
      this.itens = Array.from(this.querySelectorAll('[data-item]'));
      if (!this.itens.length) return;

      this.itens.forEach((item) => {
        const botao = item.querySelector('[data-abrir]');
        if (botao) botao.addEventListener('click', () => this.abrir(item));
      });

      const anterior = this.querySelector('[data-anterior]');
      const proximo = this.querySelector('[data-proximo]');
      if (anterior) anterior.addEventListener('click', () => this.mover(-1));
      if (proximo) proximo.addEventListener('click', () => this.mover(1));

      // No layout de círculos o vídeo abre sobre a página
      this.emJanela = this.dataset.layout === 'stories';
    }

    abrir(item) {
      this.pausarTodos();

      if (this.emJanela) {
        this.abrirJanela(item);
        return;
      }

      if (item.dataset.aberto === 'true') {
        const video = item.querySelector('video');
        if (video) video.play();
        return;
      }

      const fonte = item.querySelector('[data-fonte]');
      const capa = item.querySelector('[data-abrir]');
      if (!fonte || !capa) return;

      capa.replaceWith(fonte.content.cloneNode(true));
      item.dataset.aberto = 'true';

      const video = item.querySelector('video');
      if (video) {
        video.setAttribute('playsinline', '');
        video.play().catch(() => {});
      }
    }

    abrirJanela(item) {
      const fonte = item.querySelector('[data-fonte]');
      if (!fonte) return;

      const janela = document.createElement('div');
      janela.className = 'ma-videos__janela';
      janela.innerHTML = '<button type="button" class="ma-videos__fechar" aria-label="Fechar">&times;</button>';
      janela.appendChild(fonte.content.cloneNode(true));

      const fechar = () => {
        janela.remove();
        document.body.style.overflow = '';
        document.removeEventListener('keydown', aoTeclar);
      };
      const aoTeclar = (evento) => {
        if (evento.key === 'Escape') fechar();
      };

      janela.addEventListener('click', (evento) => {
        if (evento.target === janela || evento.target.closest('.ma-videos__fechar')) fechar();
      });
      document.addEventListener('keydown', aoTeclar);

      document.body.appendChild(janela);
      document.body.style.overflow = 'hidden';

      const video = janela.querySelector('video');
      if (video) {
        video.setAttribute('playsinline', '');
        video.play().catch(() => {});
      }
      janela.querySelector('.ma-videos__fechar').focus();
    }

    pausarTodos() {
      this.querySelectorAll('video').forEach((video) => video.pause());
    }

    mover(passo) {
      if (!this.trilho) return;
      const item = this.trilho.querySelector('[data-item]');
      if (!item) return;
      const largura = item.getBoundingClientRect().width + 16;
      this.trilho.scrollBy({ left: largura * passo, behavior: 'smooth' });
    }
  }

  if (!customElements.get('ma-videos')) customElements.define('ma-videos', MaVideos);
}
